import { allQuestions as questionBankQuestions, getQuestionsByFilters, getRandomQuestionAdvanced, getQuestionBankStats } from './questionBank';
import { DIFFICULTY_LEVELS, QUESTION_TYPES } from './questionTypes';

// Exportar todas las preguntas del banco centralizado
export const allQuestions = questionBankQuestions;

// Exportar configuraciones de dificultad y tipos
export { DIFFICULTY_LEVELS, QUESTION_TYPES };

// Definición de regiones disponibles
export const regions = [
  { id: 'cabeza', name: 'Cabeza y Cara', icon: '🧠' },
  { id: 'cuello', name: 'Cuello', icon: '🦴' },
  { id: 'torax', name: 'Tórax', icon: '🫀' },
  { id: 'abdomen', name: 'Abdomen', icon: '🫁' },
  { id: 'espalda', name: 'Espalda', icon: '💪' },
  { id: 'pelvis', name: 'Pelvis', icon: '🦵' },
  { id: 'brazo', name: 'Brazos', icon: '🦾' },
  { id: 'pierna', name: 'Piernas', icon: '🦵' }
];

// Función para obtener preguntas con filtros avanzados
export const getQuestionsByRegions = (selectedRegions, difficulties = [], types = []) => {
  return getQuestionsByFilters({
    regions: selectedRegions,
    difficulties,
    types
  });
};

// Función para mezclar preguntas aleatoriamente
export const shuffleQuestions = (questions) => {
  const shuffled = [...questions];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Función para obtener una pregunta aleatoria con filtros
export const getRandomQuestion = (selectedRegions = [], excludeIds = [], difficulties = [], types = []) => {
  return getRandomQuestionAdvanced({
    regions: selectedRegions,
    excludeIds,
    difficulties,
    types
  });
};

// Obtener estadísticas de preguntas
export const getQuestionStats = () => {
  return getQuestionBankStats();
};
